import differenceBy from 'lodash/differenceBy';
import isEqual from 'lodash/isEqual';
import keyBy from 'lodash/keyBy';

import { itemIdentity } from './utils';

export type IdentityKeyedArrayDiff = {
  added: Array<unknown>;
  removed: Array<unknown>;
  changed: Array<unknown>;
  previousByIdentity: Record<string, unknown>;
  nextByIdentity: Record<string, unknown>;
};

export function getIdentityKeyedArrayDiff(prev: Array<unknown>, next: Array<unknown>): IdentityKeyedArrayDiff {
  const previousByIdentity = keyBy(prev, itemIdentity);
  const nextByIdentity = keyBy(next, itemIdentity);
  const added = differenceBy(next, prev, itemIdentity);
  const removed = differenceBy(prev, next, itemIdentity);
  const changed = next.filter((item) => {
    const previousItem = previousByIdentity[itemIdentity(item)];
    return previousItem !== undefined && !isEqual(previousItem, item);
  });

  return { added, removed, changed, previousByIdentity, nextByIdentity };
}

export function isIdentityKeyedArrayUnchanged(diff: IdentityKeyedArrayDiff): boolean {
  return diff.added.length === 0 && diff.removed.length === 0 && diff.changed.length === 0;
}

export function formatIdentityDiffSummary(
  diff: IdentityKeyedArrayDiff,
  options: { emptyLabel?: string; fallbackLabel?: (prevCount: number, nextCount: number) => string } = {},
): string {
  const summaryParts = [
    diff.added.length > 0 ? `${diff.added.length} added` : undefined,
    diff.removed.length > 0 ? `${diff.removed.length} removed` : undefined,
    diff.changed.length > 0 ? `${diff.changed.length} changed` : undefined,
  ].filter(Boolean);

  if (summaryParts.length > 0) {
    return summaryParts.join(', ');
  }

  return options.emptyLabel ?? '';
}
